import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { environment } from "src/environments/environment";


const basePath = environment.rootApi;
@Injectable()
export class KDSService {
  authToken: string;
  constructor(private http: HttpClient) { }

  setHeaders() {
    let defaultToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiQnJhbmNoIiwibmFtZWlkIjoiQWRtaW4iLCJVc2VySWQiOiI0MDM3MiIsIlBDb2RlIjoiNDEwNjkiLCJMb2dpbklkIjoiQnVzZXIiLCJIb3RlbElkIjoiNDAyOTIiLCJWZW5kb3JJZCI6IjUwMTY2IiwiQWRtaW5JZCI6IjQwMzcyIiwiSG90ZWxOYW1lIjoiVG9zc2tleSBEZW1vIiwiTG9naW5OYW1lIjoiQnVzZXIiLCJQcm9wZXJ0eURvbWFpbkNvZGUiOiIxMDI1IiwiU2Vzc2lvbklkIjoiMCIsIkRiSXBJZCI6IjAiLCJuYmYiOjE3Mzk4NTM2NTYsImV4cCI6MTczOTk0MDA1NiwiaWF0IjoxNzM5ODUzNjU2fQ.r3qZzeyY_MXenWaGYvRfsWXbYoUKh_b-Gya3iLtFeeE'
       this.authToken = localStorage.getItem('toke') ? localStorage.getItem('toke') : defaultToken;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.authToken.replace('Bearer%20','Bearer ')
    })
    return headers;
  }

  /****************NEW ORDERS DATA ***************************** */
  getNewOrders(obj): Observable<any> {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.get(basePath + `api/DeliveryBoy/OrderGet?Id=${obj.Id}&FromDate=${obj.FromDate}&ToDate=${obj.ToDate}&DeliveryStatus=${obj.DeliveryStatus}`, { headers })
      .pipe(
        map((body: any) => {
          return body;
        },
          (error) => {
            return error;
          })
      )
  }

  getOrdersById(id): Observable<any> {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.get(basePath + `api/DeliveryBoy/OrderGet?Id=${id}`, { headers })
      .pipe(
        map((body: any) => {
          return body;
        },
          (error) => {
            return error;
          })
      )
  }

  /****************Get Delivery Boy and time slot Details***************************** */
  getDeliveryDetails(): Observable<any> {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.get(basePath + 'api/DeliveryBoy/DeliveryBoy', { headers })
      .pipe(
        map((body: any) => {
          return body;
        },
          (error) => {
            return error;
          })
      )
  }

  /****************Get Admin Status***************************** */
  getAdminStatus(reqParam): Observable<any> {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.post(basePath + 'api/DeliveryBoy/AdminStatus', reqParam, { headers })
      .pipe(
        map((body: any) => {
          return body;
        },
          (error) => {
            return error;
          })
      )
  }

  /****************Set Delivery Person***************************** */
  setDeliveryPerson(body) {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.post(basePath + 'api/DeliveryBoy/SetDeliveryBoy', body, { headers })
      .pipe(
        map((body: any) => {
          return body;
        },
          (error) => {
            return error;
          })
      )
  }

  /****************Change Order Status from kitchen***************************** */
  setKitchenStatus(body) {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.post(basePath + 'api/DeliveryBoy/KitchenStatus', body, { headers })
      .pipe(
        map((body: any) => {
          return body;
        },
          (error) => {
            return error;
          })
      )
  }

  /****************Extend Time***************************** */
  extendTime(body) {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.post(basePath + 'api/DeliveryBoy/IncressTimeSloat', body, { headers })
      .pipe(
        map((body: any) => {
          return body
        },
          (error) => {
            return error;
          })
      )
  }

  /****************Cancel Order If not Accepted***************************** */
  getDeliveryBoyCancelledOrder() {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.post(basePath + 'api/DeliveryBoy/DeliveryboyCancelorder', {}, {headers})
    .pipe(
      map((body: any) => {
        return body;
      },
      (error) => {
        return error;
      })
    )
  }

  /****************Rejection Reason List***************************** */
  getRejectedReasons(orderId) {
    const headers: HttpHeaders = this.setHeaders();
    return this.http.get(basePath + `api/DeliveryBoy/DeliveryboyCancelorder?OrderId=${orderId}`, {headers})
    .pipe(
      map((body: any) => {
        return body;
      },
      (error) => {
        return error;
      })
    )
  }
  printBill(req: any) {
    const header = new HttpHeaders();
    header.set('Content-Type', 'text/plain');
    header.set('Accept', '*');
    if(req.PrintFormat=='70MM')
    { return this.http.get('http://localhost:8743/testservice/PrintBillA3_70mm', { headers: header, params: req });}
   else
   {
    return this.http.get('http://localhost:8743/testservice/PrintBillA3', { headers: header, params: req });
   }
  }
  PrintKOT(req: any) {

    const header = new HttpHeaders();
    header.set('Content-Type', 'text/plain');
    header.set('Accept', '*');
    if(req.PrintFormat=='70MM')
    {
    return this.http.get('http://localhost:8743/testservice/PrintKotA3_70mm', { headers: header, params: req });
  }
  else
   {
    return this.http.get('http://localhost:8743/testservice/PrintKotA3', { headers: header, params: req });
   }
  }
  getSavedPrinterSettings(Id: any) {

    const headers: HttpHeaders = this.setHeaders();
    return this.http.get(basePath + `api/PosPrintterSetting/PosPrintterSetting?Id=${Id}`, {headers})
    .pipe(
      map((body: any) => {
        return body;
      },
      (error) => {
        return error;
      })
    ) 
   }
  }